import { useEffect, useState } from "react";

/**
 * Returns time-remaining info given a target ISO datetime.
 * { ms, label, tone } — tone: success (>2h), warning (<2h), danger (<0)
 */
export function getTimeRemaining(target) {
  if (!target) return { ms: null, label: "—", tone: "neutral", overdue: false };
  const ms = new Date(target).getTime() - Date.now();
  const overdue = ms < 0;
  const abs = Math.abs(ms);
  const totalMin = Math.floor(abs / 60000);
  const days = Math.floor(totalMin / (60 * 24));
  const hours = Math.floor((totalMin % (60 * 24)) / 60);
  const minutes = totalMin % 60;
  let label;
  if (days > 0) label = `${overdue ? "-" : ""}${days}d ${hours}h`;
  else label = `${overdue ? "-" : ""}${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  let tone;
  if (overdue) tone = "danger";
  else if (ms < 2 * 3600 * 1000) tone = "warning";
  else tone = "success";
  return { ms, label, tone, overdue };
}

/** Builds an ISO datetime from `YYYY-MM-DD` + `HH:MM` strings; null if missing */
export function buildDeliveryDateTime(dateStr, timeStr) {
  if (!dateStr) return null;
  const t = timeStr || "18:00";
  // Treat as local time
  return new Date(`${dateStr}T${t}:00`).toISOString();
}

/** React hook that re-renders every `intervalMs` ms (default 30s) */
export function useTicker(intervalMs = 30000) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
}
